export default __webpack_public_path__ + "static/media/Nora.23b092e9.png";